export default __webpack_public_path__ + "static/media/project9.eb036721.PNG";